import {
  type CreateSecretRequest,
  type SecretDetail,
  SecretDetailSchema,
  type SecretListQuery,
  type SecretListResponse,
  SecretListResponseSchema,
  type SecretRevealResponse,
  SecretRevealResponseSchema,
  type UpdateSecretRequest,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Secrets Manager API. List/detail responses never carry the plaintext value -
 * only `valuePreview`. The plaintext comes back solely from `revealSecret`.
 */

export const listSecrets = async (query: SecretListQuery): Promise<SecretListResponse> => {
  const { data } = await apiClient.get<unknown>('/secrets', { params: query });
  return SecretListResponseSchema.parse(data);
};

export const getSecret = async (id: string): Promise<SecretDetail> => {
  const { data } = await apiClient.get<unknown>(`/secrets/${id}`);
  return SecretDetailSchema.parse(data);
};

export const createSecret = async (payload: CreateSecretRequest): Promise<SecretDetail> => {
  const { data } = await apiClient.post<unknown>('/secrets', payload);
  return SecretDetailSchema.parse(data);
};

export const updateSecret = async (
  id: string,
  payload: UpdateSecretRequest,
): Promise<SecretDetail> => {
  const { data } = await apiClient.patch<unknown>(`/secrets/${id}`, payload);
  return SecretDetailSchema.parse(data);
};

export const deleteSecret = async (id: string): Promise<void> => {
  await apiClient.delete(`/secrets/${id}`);
};

/** Audited server-side; returns the decrypted plaintext. */
export const revealSecret = async (id: string): Promise<SecretRevealResponse> => {
  const { data } = await apiClient.post<unknown>(`/secrets/${id}/reveal`);
  return SecretRevealResponseSchema.parse(data);
};
